import React, { ReactElement } from 'react';
import type { Route } from 'next';
import classNames from 'classnames/bind';
import Breadcrumbs from 'components/Breadcrumbs';
import { EventDetails } from 'sections/Events/components/EventDetails';
import { eventDetailsData } from 'sections/Events/MembersMeeting/data';
import styles from 'sections/Events/MembersMeeting/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  return (
    <section className={cn('header')}>
        <div className={cn('container')}>
          <Breadcrumbs
            mode="light"
            links={[
              { title: 'Events', href: '/events' as Route },
              { title: 'Members Meeting', href: '' as Route },
            ]}
          />
          <div className={cn('header__content')}>
            <div className={cn('header__description')}>
              <p className={cn('header__description-suptitle')}>events</p>
              <h1 className={cn('header__description-title')}>Members Meeting</h1>
              <div className={cn('header__description-buttons-box')}>
                <a
                  className={cn('header__button', 'register')}
                  rel="nofollow"
                  href="https://assets-eur.mkt.dynamics.com/97490e54-fad8-444f-95d3-13ab26ee6605/digitalassets/standaloneforms/34a4ab24-c945-f011-877a-6045bde15d9b"
                >
                  Register
                </a>
              </div>
            </div>
            <div className={cn('header__event-details-wrap')}>
              <EventDetails eventDetailsData={eventDetailsData}/>
            </div>
          </div>
        </div>
      </section>
  );
};

export default SectionHeader;